<template>
<div class="selectBox">
    <div class="select">
        <span @click="selectBox" :name="[valName]" :value="[selectedVal]">{{selected}}</span>
        <button type="button" v-if="only" @click="search">조회</button>
    </div>
    
    <div class="dim" v-show='selectBoxView'>
        <div class="botWrap selectSlide">
            <h6>{{ selectName }}</h6>
            <ul>
                <li v-for="(option, index) of options" :key="index" @click="selected = option.text;$emit('input', option);selectedVal = option.value;$emit('input', option);selectCrt(option)">
                    <button type="button">{{ option.text }}</button>
                </li>
            </ul>
            <button type="button" class="close" @click="selectBox">닫기</button>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        only: { Type:Boolean, default: true},
        survey: { Type:Boolean, default: true},
        surveyIdx: Number,
        selectName: String,
        valName: {
            type: String,
            default: null,
        },
        options: {
            type: Array,
            required: true,
        },
        default: {
            type: String,
            required: true,
            default: null,
        },
        openMessage: {
            type: String,
            default: null,
        },
        selectedAlways: { Type:Boolean, default: false}
    },
    watch:{
        default(newVal){
            this.selected = newVal
        }
    },
    data() {       
      return {
        inputOnly: this.only,
        surveyTF: this.survey,
        surveyVal : this.surveyIdx,
        cntVal : null,
        selectBoxView: false,
        selected:
            this.default ? this.default : 
            this.options.length > 0 ? this.options[0].text : null,
        selectedVal:
            this.default ? this.default : 
            this.options.length > 0 ? this.options[0].value : null,
      };
    },
    computed:{
      
    },
    mounted() {
        this.$emit("input", this.selected); 
        this.$emit("input", this.selectedVal);    
    },
    methods: {
        selectBox : function(){
            if(!this.selectBoxView && this.openMessage){
                alert(this.openMessage);
            }
            this.selectBoxView = !this.selectBoxView;
        },
        selectCrt : function(index){
            this.cntName = index.text;
            this.cntVal = index.value;
            if(this.inputOnly == false){
                let selectVal = this.cntVal;
                this.$emit('selectSearch', selectVal);
            }
            if(this.surveyTF == false){
                let selectVal = this.cntVal;
                let idxVal = this.surveyVal;
                this.$emit('surveyVal', selectVal , idxVal);
            }
            if(this.selectedAlways == true){
                this.$emit('returnSeleted', this.selected);
            }
            this.selectBoxView = !this.selectBoxView;
        },
        search : function(){
            let selectVal = this.cntVal;
            this.$emit('selectSearch', selectVal);
        }
    },
};
</script>